export const NAVIGATION_HOVER_DELAY = 200; // ms
